/**
 * AI Chatbot Feature
 *
 * Frontend integration for the AI Chatbot (RAG) module.
 * Phase 7: Frontend Integration
 *
 * @module ChatbotFeature
 */

// Components
export {
  ChatWidget,
  ChatBubble,
  ChatWindow,
  MessageList,
  MessageItem,
  ChatInput,
  TypingIndicator,
  SuggestionChips,
} from './components';

// Hooks
export { useChatbot, useChatSocket, useSpotlight, type UseChatbotOptions } from './hooks';

// Provider
export {
  ChatbotProvider,
  useChatbotContext,
  useGuidedTour,
  type ChatbotProviderProps,
} from './providers/ChatbotProvider';

export {
  FormPrefillProvider,
  useFormPrefill,
  type FormPrefillProviderProps,
  type FormPrefillData,
} from './providers/FormPrefillProvider';

// Types
export type {
  ChatMessage,
  ChatSession,
  ChatbotState,
  ChatbotContextValue,
  MessageRole,
  MessageType,
  FeedbackRating,
  ChatLanguage,
  ChartData,
  MessageMetadata,
  MessageFeedback,
  SuggestionChip,
  UseChatSocketOptions,
} from './types';

// DEFAULT_SUGGESTIONS removed — use getDefaultSuggestions() from help-context.config (DRY)
